<template>
  <form @submit.prevent class="cliente-form">
    <input
      type="text"
      id="login"
      class="fadeIn second input-user"
      name="login"
      placeholder="DNI de USUARIO SUMÁ BENEFICIOS"
      v-model="model.dni"
    />

    <button
      :disabled="model.loggingIn"
      @click.stop="clickLogIn()"
      class="fadeIn fourth btn-iniciar"
    >
      <img v-show="!model.loggingIn" id="cb-logo" src="img/cunia-right.svg" />
      <span
        v-show="model.loggingIn"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      <span v-show="!model.loggingIn">INGRESAR</span>
    </button>
  </form>
</template>

<script>
import Swal from "sweetalert2";

export default {
  props: {
    logInWithDniFunction: Function,
  },
  data() {
    return {
      model: {
        dni: "",
        loggingIn: false,
      },
    };
  },
  methods: {
    async clickLogIn() {
      this.model.loggingIn = true;

      try {
        await this.logInWithDniFunction(this.model.dni);
      } catch (error) {
        const status = error?.response?.status ?? 0;

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            status == 404
              ? "DNI incorrecto"
              : "Ocurrió un error inesperado, vuelva a intentarlo más tarde",
        });
      }

      this.model.loggingIn = false;
    },
  },
};
</script>
<style scoped>
.btn-iniciar {
  margin-top: 20px;
  color: white;
  font-weight: bold;
  justify-self: end;
  padding-top: 3px;
  width: 158px;
  height: 31px;
  background: var(--color-exito);
  border-radius: 4px;
}
.btn-iniciar:hover {
  background: var(--color-estructura-c);
  transition-duration: 0.3s;
  transition-timing-function: ease;
  color: white;
}

.btn-iniciar span {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
  top: 1px;
  position: relative;
  margin-left: 10px;
}

.cliente-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  bottom: 50%;
}

.cliente-form > * {
  text-align: center;
  margin-bottom: 20px;
  font-family: "din-medium";
}

.input-user {
  width: 80%;
  background: transparent;
  border-bottom: 1px solid white;
  border-top: none;
  border-left: none;
  border-right: none;
  font-size: 3vw;
  height: 30px;
  color: white;
  font-size: 22px;
}

.input-user::placeholder {
  color: white;
  font-size: 12px;

  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
}

.input-user:focus {
  outline: none;
}

@media (min-width: 344px) {
  .input-user::placeholder {
    font-size: 16px;
  }
}

@media (min-width: 576px) {
  .input-user {
    font-size: 2.5vw;
    width: 60%;
  }
}
@media (min-width: 768px) {
  .cliente-form {
    bottom: 20%;
  }
  .cliente-form > * {
    margin-bottom: 30px;
  }

  .input-user {
    width: 70%;
    font-size: 1.8vw;
  }
}
@media (min-width: 992px) {
  .input-user {
    width: 50%;
    font-size: 1.2vw;
  }
}
@media (min-width: 1200px) {
  .input-user {
    width: 438px;
  }
}
</style>
